export default __webpack_public_path__ + "static/media/darkLeaderboardIcon.fdcecbc3.svg";